import React from "react";
import { motion } from "framer-motion";
import { TRUST } from "../../data";

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="bg-white pt-14 md:pt-16 pb-4">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid sm:grid-cols-3 gap-5 md:gap-6">
          {TRUST.map((t, i) => {
            const Icon = t.icon;
            return (
              <motion.div
                key={t.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`trust-card-${i}`}
                className="flex items-start gap-4 rounded-2xl bg-[#EAF7FC] border border-[rgba(19,57,85,0.06)] p-6 hover:-translate-y-1 transition-transform duration-300"
              >
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#54BCE6] text-[#133955] shrink-0">
                  <Icon size={22} />
                </span>
                <div>
                  <p className="font-display text-lg font-bold text-[#133955] leading-tight">{t.title}</p>
                  <p className="text-sm text-[#173042]/75 mt-1">{t.body}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
